var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as moment from 'moment-timezone';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material';
import { ExerciseService } from 'app/shared/services/exercises.service';
import { VideoDialogComponent } from 'app/theme/components/videoDialog/videoDialog.component';
/**
 * Component to displayed leaderboard of a challenge
 */
var ChallengeLeaderboardBonusComponent = (function () {
    function ChallengeLeaderboardBonusComponent(challengeService, exerciseService, dialog) {
        this.challengeService = challengeService;
        this.exerciseService = exerciseService;
        this.dialog = dialog;
        this.ngUnsubscribe = new Subject();
    }
    ChallengeLeaderboardBonusComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Fetch freshen up module in order to allow opening freshen up video dialog by clicking on bonus
        this.exerciseService.getModules().then(function (modules) {
            _this.freshenUpModule = modules.find(function (mod) { return mod.title.de === 'Frischmacher' || mod._id === '5a9db3d00db3c60000ad6fef'; });
            _this.relaxerModule = modules.find(function (mod) { return mod.title.de === 'Ausgleicher' || mod._id === '5a9db5ae0db3c60000ad6ff2'; });
            _this.updateBonusAvailability();
        });
    };
    ChallengeLeaderboardBonusComponent.prototype.ngOnChanges = function () {
        this.updateBonusAvailability();
    };
    /**
     * Start freshenUp module or relaxer module by clicking on bonus
     * @param module
     */
    ChallengeLeaderboardBonusComponent.prototype.openVideoDialog = function (module) {
        var _this = this;
        var dialogOpened;
        this.exerciseService.createRandomProgram(module, undefined).then(function (program) {
            dialogOpened = moment();
            var dialogRef = _this.dialog.open(VideoDialogComponent, {
                panelClass: 'app-video-dialog-container',
                // width: '60vw',
                position: {
                    top: '5vh',
                },
                data: { program: program, canGoBack: false },
            });
            dialogRef
                .afterClosed()
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (result) { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    // If at least 15 seconds passed, mark module as finished
                    if (moment().diff(dialogOpened, 'seconds') >= 15) {
                        // Send request to backend to indicate that user completed a module
                        this.exerciseService.moduleFinished(module._id).then(function () {
                            _this.challengeService.reloadTeams();
                        });
                    }
                    return [2 /*return*/];
                });
            }); });
        });
    };
    /**
     * On destroy cancel active subscriptions
     */
    ChallengeLeaderboardBonusComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    /**
     * Update whether tea time and freshenUp bonus are available
     */
    ChallengeLeaderboardBonusComponent.prototype.updateBonusAvailability = function () {
        if (!this.currentUser) {
            return;
        }
        if (!this.isWorkday()) {
            this.teaTimeBonusAvailable = false;
            this.freshenUpBonusAvailable = false;
            return;
        }
        var currentUserTime = moment().tz(this.currentUser.timeZone);
        if (this.teamUser.bonuses.teatime.days.includes(this.currentChallengeDay)) {
            this.teaTimeBonusAvailable = false;
        }
        else if (currentUserTime.hours() < 15) {
            this.teaTimeBonusAvailable = false;
        }
        else {
            this.teaTimeBonusAvailable = true;
        }
        if (this.teamUser.bonuses.freshenUp.days.includes(this.currentChallengeDay)) {
            this.freshenUpBonusAvailable = false;
        }
        else if (currentUserTime.hours() < 11 || (currentUserTime.hours() === 11 && currentUserTime.minutes() < 30)) {
            this.freshenUpBonusAvailable = true;
        }
        else {
            this.freshenUpBonusAvailable = false;
        }
    };
    /**
     * Check whether now is a workday in users timezone
     * @param timeZone - timeZone
     */
    ChallengeLeaderboardBonusComponent.prototype.isWorkday = function () {
        if (!this.currentUser) {
            return;
        }
        var day = moment().tz(this.currentUser.timeZone).day();
        if (day > 0 && day < 6) {
            return true;
        }
        return false;
    };
    return ChallengeLeaderboardBonusComponent;
}());
export { ChallengeLeaderboardBonusComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/challenge-statistics/components/challenge-leaderboard/components/challenge-leaderboard-bonus/challenge-leaderboard-bonus.component.ts.pre-build-optimizer.js